import {useState, type Dispatch} from 'react'

type Item = string | null

export function useLocalStorage(key: string, initialState: Item | (() => Item)): [Item, Dispatch<Item>] {
  const [value, setStateValue] = useState(localStorage.getItem(key) || initialState)

  const setValue: Dispatch<Item> = (newValue: Item) => {
    if (newValue) localStorage.setItem(key, newValue)
    else localStorage.removeItem(key)

    setStateValue(newValue)
    return newValue
  }
  return [value, setValue]
}
